/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Class_Kostenstellesubgroup3Inputs */



/**

* @param {_Class_Kostenstellesubgroup3Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _class_kostenstellesubgroup3 = /** @type {((inputs?: _Class_Kostenstellesubgroup3Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Class_Kostenstellesubgroup3Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Standard-Gruppe")
});
export { _class_kostenstellesubgroup3 as "_class_KostenstelleSubGroup" }